<template>
  <div class="w-100 h-100">
    <!-- <dv-border-box-7 style="vertical-align: middle;">
      <div style="width: 100%; height: 100%">
        <el-carousel style="width: 100%; height:80%;" type="card" ref="nop" arrow="never" :interval="1000" :autoplay="false">
          <el-carousel-item>
            <div style="width: 33.33%; height: 80%" id="jobFiex" class="scropDiv"></div>
          </el-carousel-item>
          <el-carousel-item v-for="(item, i) in totals" style="width: 100%; height:100%;" :key="item + i">
            <div style="width: 33.33%; height: 80%" :id="'job-'+i"></div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </dv-border-box-7> -->
    <dv-border-box-7 style="vertical-align: middle;height:100%;">
      <div id="jobContent" style="width: 100%;height:95%;padding:1%;">
        <el-row :gutter="24">
          <el-col :span="6">
            <div :style="{ 'width': jWeight + 'px', 'height': jHeight + 'px' }" id="jobFiex"></div>
          </el-col>
          <el-col :span="18">
            <carousel :perPage="3" :loop="true" :paginationEnabled="false" :scrollPerPage="false" :autoplay="true">
              <template v-for="(item, i) in totals">
                <slide :key="item.departmentId + i" v-if="i > 0">
                  <div :style="{ 'width': jWeight + 'px', 'height': jHeight + 'px' }" @click="viewPlanList(item)"
                    :id="'job-' + i"></div>
                </slide>
              </template>
            </carousel>
          </el-col>
        </el-row>
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="本月的审核计划，按审核计划结束时间查询，显示未开始、进行中、已完成、超时的计划，按审核员的岗位分组显示，可点击显示详情！"
          placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>

    <el-dialog :z-index="99999" :title="jobTitle + ' 审核计划列表'" :visible.sync="planDialog" width="80%">
      <el-table v-loading="planLoading" :data="pagedPlanList" border style="width: 100%; padding-top: 15px">
        <el-table-column align="center" show-overflow-tooltip min-width="250" prop="template.title" label="审核表">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip min-width="180" prop="station.productionLine.title" label="产线">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip min-width="120" prop="station.title" label="工位">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip min-width="120" prop="auditor.name" label="审核员">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip min-width="120" prop="auditor.department.title" label="部门">
        </el-table-column>
        <el-table-column align="center" min-width="120" :formatter="gridcreatedFormatter" prop="startTime" label="开始时间">
        </el-table-column>
        <el-table-column align="center" min-width="120" prop="endTime" :formatter="gridcreatedFormatter" label="结束时间">
        </el-table-column>
        <el-table-column align="center" min-width="120" prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">未开始</span>
            <span v-if="scope.row.status == 1">进行中</span>
            <span v-if="scope.row.status == 2">已完成</span>
            <span v-if="scope.row.status == 3">已超时</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handlePlanSizeChange"
        @current-change="handlePlanCurrentChange"
        :current-page="planPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="planSize"
        :total="planList.length"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 15px; text-align: right;">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/utils/api";
import parse from "date-fns/fp/parse/index";
import format from "date-fns/format";
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: "lpa-progress",
  components: {
    Carousel,
    Slide
  },
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
    line: {
      type: String,
      default: function () {
        return null;
      },
    },
    finishedColor: {
      type: String,
      default: function () {
        return '#54A2D5';
      },
    },
    unfinishedColor: {
      type: String,
      default: function () {
        return '#FF5B4D';
      },
    },
    tempCategory: {
      type: String,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      totals: [],
      bor_show: true,
      startCharts: null,
      planList: [],
      planPage: 1,
      planSize: 10,
      planDialog: false,
      planLoading: false,
      jobTitle: "",
      productLine: null,
      templateCategoryUUID: null,
      jWeight: 0,
      jHeight: 0
    };
  },
  computed: {
    pagedPlanList() {
      const start = (this.planPage - 1) * this.planSize;
      return this.planList.slice(start, start + this.planSize);
    },
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.totals = val;
        var _this = this;
        this.$nextTick(() => {
          _this.pieEchart();
        });
      },
      deep: true,
    },
    line: {
      handler: function (val, oldVal) {
        this.productLine = val;
      },
      deep: true,
    },
    tempCategory: {
      handler: function (val, oldVal) {
        this.templateCategoryUUID = val;
      },
      deep: true,
    },
  },
  mounted() {
    this.documentWH();
  },
  methods: {
    handleAnimationEnd(animationTarget) {
      // 当动画结束时，如果动画目标是最后一个元素，则跳转到第一个元素
      console.log(1234);
      if (animationTarget === 4) {
        this.$refs.carousel.goToPage(0); // 假设你的ref设置为carousel
      }
    },
    dataSlice(index, data) {
      return data.slice(index);
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },

    viewPlanList(item) {
      this.jobTitle = item["departmentTitle"];
      this.planDialog = true;
      var jobUUID = item["departmentId"];
      if (item["departmentId"] === 'jobGrade') {
        jobUUID = this.jobTitle;
      }
      var that = this;
      var params = { jobUUID: jobUUID };
      if (this.productLine) {
        params["productLine"] = this.productLine;
      }
      if (this.templateCategoryUUID) {
        params["templateCategoryUUID"] = this.templateCategoryUUID;
      }
      that.planLoading = true;
      API.loadJobPlans(params)
        .then((res) => {
          if (res.success === true) {
            this.planList = res["list"];
            this.planPage = 1;
          }
          this.planLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.planLoading = false;
        });
    },
    handlePlanSizeChange(val) {
      this.planSize = val;
      this.planPage = 1;
    },
    handlePlanCurrentChange(val) {
      this.planPage = val;
    },
    gridcreatedFormatter(row, column, value) {
      return format(new Date(value), "yyyy-MM-dd");
    },
    scrrollTop() {
      var parent = document.getElementById("borderStyle");
      var len = 0;
      var width = parent.clientWidth;
      var totLeng = this.totals.length - 1; //有一个固定,需要减一
      var pushWidht = parseFloat(width / 4);
      if (totLeng > 4) {
        totLeng -= 4;
        setInterval(function () {
          if (len >= totLeng) {
            parent.scrollLeft = 0;
            len = 0;
          } else {
            parent.scrollLeft += pushWidht;
            len += 1;
          }
        }, 100);
      }
    },
    documentWH() {
      var parent = document.getElementById("jobContent");
      var width = parent.clientWidth;
      var height = parent.clientHeight;
      this.jWeight = parseInt(width / 4) - 10;
      this.jHeight = height;
    },
    pieEchart() {
      var _this = this;
      var datas = this.totals;
      for (var i = 0; i < datas.length; i++) {
        var data = datas[i];
        var title = data["departmentTitle"];
        var value = data["actualCount"]; //已完成计划
        var total = data["plannedCount"]; //所有计划
        var unTotal = total - value;
        var rate = 100;
        if (total > 0) {
          rate = parseInt((value / total) * 100 + "", 0);
        }
        var option = {
          // 标题组件，包含主标题和副标题
          title: {
            show: true,
            x: "center",
            textStyle: {
              fontSize: "22",
              color: "#FFFFFF",
              fontWeight: "bold",
            },
          },
          //  提示框组件
          tooltip: {
            //是否显示提示框组件，包括提示框浮层和 axisPointe
            show: false,
            // 触发类型: item:数据项触发，axis：坐标轴触发
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)",
          },

          series: [
            {
              // 系列名称，用于tooltip的显示，legend 的图例筛选，在 setOption 更新数据和配置项时用于指定对应的系列。
              name: "任务进度",
              type: "pie",
              animation: false,
              // 饼图的半径，数组的第一项是内半径，第二项是外半径
              radius: ["100%", "80%"],
              // 是否启用防止标签重叠策略，默认开启
              avoidLabelOverlap: false,
              hoverAnimation: false,
              // 标签的视觉引导线样式，在 label 位置 设置为'outside'的时候会显示视觉引导线
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: [
                {
                  // 数据值
                  value: value,
                  // 数据项名称
                  name: title,
                  //该数据项是否被选中
                  selected: false,
                  itemStyle: { color: this.finishedColor },
                  // 单个扇区的标签配置
                  label: {
                    normal: {
                      // 是显示标签
                      show: true,
                      position: "center",
                      fontSize: _this.fontSize(0.22),
                      color: "#FFFFFF",
                      // 标签内容格式器，支持字符串模板和回调函数两种形式，字符串模板与回调函数返回的字符串均支持用 \n 换行
                      formatter: function (val) {
                        return (
                          title +
                          "\n\n进度：" +
                          rate +
                          "\t%" +
                          "\n\n总计划：" +
                          total
                        );
                      },
                    },
                  },
                },
                {
                  value: unTotal,
                  label: {
                    normal: {
                      show: false,
                    },
                  },
                  itemStyle: { color: this.unfinishedColor },
                },
              ],
            },
          ],
        };

        if (i == 0) {
          //第一个固定
          var pipeo = this.$echarts.init(document.getElementById("jobFiex"));
          pipeo.setOption(option);
        } else {
          var pipe1 = this.$echarts.init(document.getElementById("job-" + i));
          pipe1.setOption(option);
        }
      }
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
#borderStyle {
  width: 95%;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  white-space: nowrap;
  float: left;
  text-align: center;
  margin-left: 2%;
  scroll-behavior: smooth;
}

.scropDiv {
  position: relative;
  display: inline-block;
}

.item {
  padding: 0.33rem 0.4rem 0.2rem;
}

/*左边中间部分排行榜*/
.biaoge_pai {
  overflow: hidden;
}

.biaoge_pai ul li {
  height: 20%;
}

.biaoge_pai ul li .liIn {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  color: #fff;
  font-size: 0.06rem;
  height: 0.6rem;
}

.biaoge_pai ul li .liIn .liIn_left {
  width: 25%;
  position: relative;
  padding-left: 0.3rem;
}

.biaoge_pai ul li .liIn .liIn_left .bot {
  width: 0.2rem;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 1000px;
  display: block;
  position: absolute;
  left: 0.02rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.biaoge_pai ul li .liIn2 .liIn_left .bot {
  background: #e7feb8;
}

.biaoge_pai ul li .liIn3 .liIn_left .bot {
  background: #fdea8a;
}

.biaoge_pai ul li .liIn4 .liIn_left .bot {
  background: #8ff9f8;
}

.biaoge_pai ul li .liIn5 .liIn_left .bot {
  background: #91cc75;
}

.biaoge_pai ul li .liIn6 .liIn_left .bot {
  background: #05d1fc;
}

.biaoge_pai ul li .liIn .liIn_line {
  width: 58%;
  height: 0.2rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2000px;
}

.biaoge_pai ul li .liIn .liIn_line .line_lineIn {
  width: 100%;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 100px;
  -webkit-animation: widthMove1 2s ease-in-out;
}

.biaoge_pai ul li .liIn2 .liIn_line .line_lineIn {
  background: #e7feb8;
  -webkit-animation: widthMove2 2s ease-in-out;
}

.biaoge_pai ul li .liIn3 .liIn_line .line_lineIn {
  background: #fdea8a;
  -webkit-animation: widthMove3 2s ease-in-out;
}

.biaoge_pai ul li .liIn4 .liIn_line .line_lineIn {
  background: #8ff9f8;
  -webkit-animation: widthMove4 2s ease-in-out;
}

.biaoge_pai ul li .liIn5 .liIn_line .line_lineIn {
  background: #d890fa;
  -webkit-animation: widthMove5 2s ease-in-out;
}

.biaoge_pai ul li .liIn6 .liIn_line .line_lineIn {
  background: #05d1fc;
  -webkit-animation: widthMove6 2s ease-in-out;
}

@-webkit-keyframes widthMove1 {
  0% {
    width: 0%;
  }

  100% {
    width: 98.5%;
  }
}

@-webkit-keyframes widthMove2 {
  0% {
    width: 0%;
  }

  100% {
    width: 88.5%;
  }
}

@-webkit-keyframes widthMove3 {
  0% {
    width: 0%;
  }

  100% {
    width: 68.5%;
  }
}

@-webkit-keyframes widthMove4 {
  0% {
    width: 0%;
  }

  100% {
    width: 40.5%;
  }
}

@-webkit-keyframes widthMove5 {
  0% {
    width: 0%;
  }

  100% {
    width: 22.5%;
  }
}

@-webkit-keyframes widthMove6 {
  0% {
    width: 0%;
  }

  100% {
    width: 10.5%;
  }
}

.biaoge_pai ul li .liIn .num {
  font-family: dig;
  padding-left: 0.1rem;
}

.content {
  height: 100%;
  width: 100%;
}

.content div {
  float: left
}

.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/layeraudit/component/job-total.vue